import { Box, Text, VStack } from "@chakra-ui/react";
import { InfoOutlined as InfoOutlinedIcon } from "@mui/icons-material";
import { FC } from "react";

import { Tooltip } from "~/src/components/common/Tooltip";

type Props = {
  linkedPopupGroupNames: string[];
  linkedAbtestGroupTitles: string[];
  isDistributionGated?: boolean;
};

export const ModuleLinkedGroupsTooltip: FC<Props> = ({
  linkedPopupGroupNames,
  linkedAbtestGroupTitles,
  isDistributionGated = false,
}) => {
  const hasLinkedGroups =
    linkedPopupGroupNames.length > 0 || linkedAbtestGroupTitles.length > 0;

  if (!hasLinkedGroups) {
    return null;
  }

  return (
    <Tooltip
      aria-label="紐付け先一覧"
      placement="top"
      hasArrow
      openDelay={200}
      label={
        <Box maxW="320px" py={1}>
          {isDistributionGated && (
            <Text fontSize="xs" color="gray.100" mb={2}>
              リンク先の配信条件を満たした訪問時のみ実行されます。条件の変更は自動的に反映されます。
            </Text>
          )}
          {linkedPopupGroupNames.length > 0 && (
            <Box mb={linkedAbtestGroupTitles.length > 0 ? 2 : 0}>
              <Text fontSize="xs" fontWeight="semibold" mb={1}>
                ポップアップグループ
              </Text>
              <VStack align="stretch" spacing={0.5}>
                {linkedPopupGroupNames.map((name) => (
                  <Text key={`popup-${name}`} fontSize="xs">
                    {name}
                  </Text>
                ))}
              </VStack>
            </Box>
          )}
          {linkedAbtestGroupTitles.length > 0 && (
            <Box>
              <Text fontSize="xs" fontWeight="semibold" mb={1}>
                ABテストグループ
              </Text>
              <VStack align="stretch" spacing={0.5}>
                {linkedAbtestGroupTitles.map((title) => (
                  <Text key={`abtest-${title}`} fontSize="xs">
                    {title}
                  </Text>
                ))}
              </VStack>
            </Box>
          )}
        </Box>
      }
    >
      <Box
        as="span"
        display="inline-flex"
        alignItems="center"
        color="black"
        cursor="default"
        lineHeight={0}
        _hover={{ color: "#1867C0", opacity: 0.6 }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </Box>
    </Tooltip>
  );
};
